import { render, staticRenderFns } from "./ClientsPage.vue?vue&type=template&id=37055280&"
import script from "./ClientsPage.vue?vue&type=script&lang=js&"
export * from "./ClientsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports